"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cantalupo-in-sabina": {
    "28865366": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "piedimordenti": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8b637fc": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "terra": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20931054": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "vallemare": [{
      "hkey": "4b5206dd",
      "slug": "cantalupo-in-sabina",
      "name": "Cantalupo in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;